import React from "react";
import { Col, Row } from "react-bootstrap";
import FormSection from "components/v2/FormSection/FormSection";
import FormHeader from "components/v2/FormSection/components/FormHeader/FormHeader";
import { FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";

interface IShipmentRoute {
  isLoading?: boolean;
}

function ShipmentRoute({ isLoading }: IShipmentRoute) {
  const methods = useFormContext();
  const { schedule } = methods.getValues();

  const {
    pickup_address_name,
    pickup_street,
    pickup_street_line2,
    pickup_city,
    pickup_country,
    pickup_zipcode,
    stop1_address_name,
    stop1_street,
    stop1_street_line2,
    stop1_city,
    stop1_country,
    stop1_zipcode,
  } = schedule || {};

  const formatAddress = (street: string, streetLine2: string, city: string, country: string, zipcode: string) =>
    [street, streetLine2, city, country, zipcode].filter(Boolean).join(", ").replace(/, $/, "");

  return (
    <div className="mt-3xl">
      <FormSection>
        <FormHeader title="Shipment route" />
        <div className="form-section-content">
          <div>
            {isLoading ? (
              Array.from({ length: 1 }).map((_, index) => (
                <Row key={index}>
                  <Col className="pt-0 pb-0 overflow-hidden">
                    <LoadingSkeleton rows={1} bodyClasses="p-0" className="p-0" noShadow />
                  </Col>
                </Row>
              ))
            ) : (
              <Row>
                <Col>
                  <div className="text-sm font-medium text-secondary-v2">
                    <FormattedMessage id="general.origin" defaultMessage="Origin" />
                  </div>
                  <div className="text-md font-medium text-primary">{pickup_address_name}</div>
                  <div className="text-md font-regular text-primary">
                    {formatAddress(pickup_street, pickup_street_line2, pickup_city, pickup_country, pickup_zipcode)}
                  </div>
                </Col>
                <Col>
                  <div className="text-sm font-medium text-secondary-v2">
                    <FormattedMessage id="general.destination" defaultMessage="Destination" />
                  </div>
                  <div className="text-md font-medium text-primary">{stop1_address_name}</div>
                  <div className="text-md font-regular text-primary">
                    {formatAddress(stop1_street, stop1_street_line2, stop1_city, stop1_country, stop1_zipcode)}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </FormSection>
    </div>
  );
}

ShipmentRoute.defaultProps = {
  isLoading: false,
};

export default ShipmentRoute;
